import React from "react";
import * as QueryString from "query-string"
import { Locale } from "../../core/api/model";
import { ContactPage, ContactPageType } from "../components";
import NotFound from "../../core/errors/not-found";

export interface ContactProps {
  locale: Locale;
  showErrorModal: (title: string, description: string, raw?: any) => void;
}

export const ContactMeet = (props: ContactProps) => {
  const params = QueryString.parse(window.location.search);
  const expertId: number = Number(params['expertId']);

  if (Number.isNaN(expertId)) {
    return <NotFound />
  }

  return (
    <ContactPage
      locale={props.locale}
      type={ContactPageType.Meet}
      expertId={expertId}
      showErrorModal={props.showErrorModal}
    />
  );
};
